import { render, staticRenderFns } from "./FriendshipBrokerSearchResult.vue?vue&type=template&id=02955594&scoped=true"
import script from "./FriendshipBrokerSearchResult.vue?vue&type=script&lang=ts"
export * from "./FriendshipBrokerSearchResult.vue?vue&type=script&lang=ts"
import style0 from "./FriendshipBrokerSearchResult.vue?vue&type=style&index=0&id=02955594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02955594",
  null
  
)

export default component.exports